<template>
<m-pageframe
    title="RedChirp Alerts"
>
<v-container
    fluid
    style="padding-left: 30px; padding-right: 30px"
>

    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
    >
        <v-menu
            bottom
            offset-y
            slot="append-outer"
        >
            <template v-slot:activator="{ on }">
                <v-icon
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
            </template>
    
            <v-list>
                <v-list-item
                    v-on:click="doUpdate"
                >
                    <v-list-item-title>Refresh</v-list-item-title>
                </v-list-item>

                <v-divider/>

                <v-list-item
                    v-on:click="onClickAlertSettings"
                >
                    <v-list-item-title>Edit your alert settings...</v-list-item-title>
                </v-list-item>

                <v-divider/>

                <v-list-item
                    v-on:click="onClickSendTestAlert"
                >
                    <v-list-item-title>Send test alert...</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu> 
    </v-text-field>

    <v-select
        label="Alert Type"
        v-model="alert_type"
        :items="$rc.enumChoices('alert_type',true)"
        v-on:change="doUpdate"
    >
    </v-select>

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
    
        <template v-slot:item.time_date="{ item }">
            {{$rc.pretty(item.time,'date')}}
        </template>

         <template v-slot:item.time_time="{ item }">
            {{$rc.pretty(item.time,'time')}}
        </template>

        <template v-slot:item.action="{ item }">
            <v-menu 
                bottom 
                offset-y  
            >
            
            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical-circle-outline
                </v-icon>
                    
            </template>
            
            <v-list>
                <v-list-item
                    v-on:click="onClickDetails(item)"
                >
                    <v-list-item-title>Details...</v-list-item-title>
                </v-list-item>
            
            </v-list>
            
            </v-menu> 
        </template>
    
    </v-data-table>

    <m-admin-alert-details-dialog
        ref="alert-details-dialog"
    />

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');

export default {
    data() {
        return {
            full_text: null,
            alert_type: 'any_enum_value',
            results: [],
            headers: [
                { text: 'Date', value: 'time_date'},
                { text: 'Time', value: 'time_time'},
                { text: 'Type', value: 'alert_type'},
                { text: 'Text', value: 'text_content'},
                { text: 'Action', value: 'action'},
            ],
        }
    },

    mounted () {
        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/alert',
            
                'params' : {
                        'full_text': this.full_text,
                        'alert_type': this.alert_type == 'any_enum_value' ? null : this.alert_type,
                        'sort': 'time:desc',
                    },
            
                'on_success': (data) => {
                        this.results = data.results;
                    },
            
                'on_error': 'Unable to complete API call',
            });
        },

        onClickAlertSettings()
        {
            this.$router.push({
                'name': 'alert-delivery-preferences',
                'params' : {
                    'employee_id': this.$rc.$state.getEmployeeId(),
                }
            });
        },

        onClickSendTestAlert()
        {
            this.$rc.prompt({
                    'title' : 'Send test alert',
                    'label' : 'Test alert message',
                    'value' : 'Ahoy Alerts!',
                    'after_prompt' : (value) => {

                       this.$rc.rest({
                        'spinner': true,
                        'endpoint': 'PUT: /api/v1/alert/trigger-test-alert',
                       
                        'params' : {
                                'message' : value
                            },
                       
                        'on_success': (data) => {
                                this.$rc.snackbar('Test alert sent');

                                this.doUpdate();
                            },
                       
                        'on_error': 'Unable to send test alert',
                       });
                    }
                });
        },

        onClickDetails(item)
        {
            this.$refs['alert-details-dialog'].showDialog(item.alert_id);
        },
    },
}
</script>

<style lang="scss" scoped>
</style>
